import { AgColumnDefinition, AgGridColumnType, AgGridExportType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'

export const billingGridInvoicesColumnDefs =
    (): Array<AgColumnDefinition> => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            headerName: i18n.tc('accounting.field.invoice'),
            field: 'label',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.client'),
            field: 'customer.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.generationDate'),
            field: 'generationDate',
            type: AgGridColumnType.DATETIME,
            exportType: AgGridExportType.DATETIME,
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.generationResponsible'),
            colId: 'generator.normalizedFullName',
            field: 'generator.fullName',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.cancellationDate'),
            field: 'cancellationDate',
            type: AgGridColumnType.DATETIME,
            exportType: AgGridExportType.DATETIME,
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.cancellationResponsible'),
            colId: 'canceller.normalizedFullName',
            field: 'canceller.fullName',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.verificationDate'),
            field: 'verificationDate',
            type: AgGridColumnType.DATETIME,
            exportType: AgGridExportType.DATETIME,
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.verificationResponsible'),
            colId: 'verifier.normalizedFullName',
            field: 'verifier.fullName',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.deliveryNote', 2),
            field: 'billableDeliveryNoteCount',
            type: AgGridColumnType.NUMBER,
            exportType: AgGridExportType.NUMBER,
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            headerName: i18n.tc('accounting.field.concept', 2),
            field: 'appliedBillableConceptsCount',
            type: AgGridColumnType.NUMBER,
            exportType: AgGridExportType.NUMBER,
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            headerName: i18n.tc('accounting.field.total'),
            field: 'conceptsTotalValue',
            type: AgGridColumnType.DECIMAL,
            exportType: AgGridExportType.DOUBLE,
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.unit'),
            field: 'conceptsAccountingUnit.symbol',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.realTotal'),
            field: 'realTotalValue',
            type: AgGridColumnType.DECIMAL,
            exportType: AgGridExportType.DOUBLE,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.realUnit'),
            field: 'realAccountingUnit.symbol',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.externalIdentifier'),
            field: 'externalReference',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        // Temporally hidden
        // {
        //     headerName: i18n.tc('accounting.field.paymentDate'),
        //     field: 'paymentDate',
        //     type: AgGridColumnType.DATETIME,
        //     exportType: AgGridExportType.DATETIME,
        //     minWidth: 100,
        //     flex: 1,
        //     suppressSizeToFit: true
        // },
        // {
        //     headerName: i18n.tc('accounting.field.paymentMethod'),
        //     field: 'paymentMethod.name',
        //     type: AgGridColumnType.TEXT,
        //     exportType: AgGridExportType.TEXT,
        //     minWidth: 100,
        //     flex: 1,
        //     suppressSizeToFit: true
        // },
        {
            headerName: i18n.tc('accounting.field.selfBilling'),
            field: 'isForAutoInvoice',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.inmediateSupplyOfInformation'),
            field: 'sentToGovernmentRevenueServices',
            type: AgGridColumnType.CHECK_ICON,
            exportType: AgGridExportType.BOOLEAN,
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]
